// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/patient-kpi/patient-kpi.less
// module id = 3802
// module chunks = 0